import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/especialidade`;
export const createEspecialidade = async (especialidade) => {
  return await axios.post(`${httpUrl}/create`, especialidade).then((response) => response);
};

export const getEspecialidades = async () => {
  return await axios.get(`${httpUrl}/list`).then((response) => response);
};

export const getEspecialidadeById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteEspecialidade = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
